import styled from '../../../theme'
import Badge from '../../Template/Badge'

const Button = styled(Badge.withComponent('a'))<{ size?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: ${({ size }) => (size ? 31 * size : 31)}px;
  width: ${({ size }) => (size ? 31 * size : 31)}px;
  height: ${({ size }) => (size ? 25 * size : 25)}px;

  padding: 0;

  &:hover {
    cursor: pointer;
  }
`

const DecreaseButton = styled(Button)<{ size?: number }>``
const IncreaseButton = styled(Button)<{ size?: number }>``

export { DecreaseButton, IncreaseButton }
